import './styles/variables.css'
import './styles/globalStyle.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ProtectedRoute from "./layouts/ProtectedRoute";
import { PrivateLayOut } from './layouts/PrivateLayOut';
import { MemberManagement } from './components/Routes/MemberManagement/MemberManagement'
import { TpaTraining } from './components/Routes/TPAtraining/TpaTraining'
import { ToggleProvider } from './context/toggle/toggleBtn';
import { AccountOverview } from './components/dashboard/subContent/MobileUserPage/AccountOverview';
import { HeaderMain } from './components/dashboard/subContent/responsiveHeader/HeaderMain';
import { PublicLayout } from './layouts/PublicLayout';
import { Login } from './components/user/Auth/login/pages/Login/Login';

import { Delivery } from './components/Routes/Delivery/Delivery';
import { Outbox } from './components/Routes/Outbox/Outbox';
import { Communication } from './components/Routes/Communication/Communication';
import { RenewSubscription } from './components/Routes/RenewSubscription/RenewSubscription';
import { AdminLogs } from './components/Routes/AdminLogs/AdminLogs';
import { Formations } from './components/Routes/Formations/Formations';
import { FormationDetails } from './components/Routes/Formations/FormationDetails/FormationDetails';
import { ScrollToTop } from './components/common/scrollToTop/ScrollToTop';
import { useEffect } from 'react';
import { scheduleTokenRefresh } from './helper/auth/tokenManagger';
import { VisitorsLayOut } from './layouts/VisitorsLayOut';
import { PrivateCleanLayOut } from './layouts/PrivateCleanLayOut';


function App() {

  useEffect(() => {
    const hasAccessToken = localStorage.getItem('access-token');
    const hasRefreshToken = localStorage.getItem('refresh-token');

    if (hasAccessToken && hasRefreshToken) {
      scheduleTokenRefresh();
    }
  }, []);


  return (
    <ToggleProvider>
      <BrowserRouter>


        <ScrollToTop />

        <Routes>

          <Route element={<PublicLayout />}>

            <Route path='/login' element={<Login />} />


          </Route>

          {/* <Route element={<VisitorsLayOut/>}>

            <Route path="/FormationInfo/:FormationId" element={<FormationDetails mode='info' />} />

          </Route> */}


          <Route
            element={
              <ProtectedRoute>
                <PrivateLayOut />
              </ProtectedRoute>
            }
          >

            <Route path="*" element={<MemberManagement />}></Route>
            <Route path="/Member" element={<MemberManagement />} />
            <Route path="/TPAtraining" element={<TpaTraining />} />
            <Route path="/Delivery" element={<Delivery />} />
            <Route path="/Outboxes" element={<Outbox />} />
            <Route path="/Communications" element={<Communication />} />
            <Route path="/Renewal" element={<RenewSubscription />} />
            <Route path="/AdminLogs" element={<AdminLogs />} />
            <Route path="/Formations" element={<Formations />} />
            <Route path="/FormationsDetail/:FormationId" element={<FormationDetails />} />
            {/* <Route path="/FormationInfo/:FormationId" element={<FormationDetails mode='info' />} /> */}


          </Route>




          <Route
            element={
              <ProtectedRoute>
                <PrivateCleanLayOut />
              </ProtectedRoute>
            }
          >
            <Route
              path="/FormationInfo/:FormationId" element={<FormationDetails mode="info" />}
            />
          </Route>



          {/* Cuando me redirija a /MemberDetail, <AccountOverview /> se renderizara en <ProtectedRoute> */}

          <Route
            path="/MemberDetail/:UserId"
            element={
              <ProtectedRoute>
                <AccountOverview />
                {/* <HeaderMain/> */}
              </ProtectedRoute>
            }
          />

        </Routes>

      </BrowserRouter>

    </ToggleProvider>

  )
}

export default App;
